import { render } from "./FolderMove.vue?vue&type=template&id=e3d1baf8"
import script from "./FolderMove.vue?vue&type=script&lang=js"
export * from "./FolderMove.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__